/* eslint-disable no-unused-vars */
/* Keeping Variables in here in case we ever need to add analytics back */
import { Logger } from 'lib'

class Analytics {
  constructor () {
    this.log = new Logger(this.constructor.name)
  }

  checkEligibility () {
    // nuke the local cookie, to ensure we can still write it and read it back

    // try to set the cookie and see if we can read it back

    return false
  }

  initialize () {
    if (!this.checkEligibility()) {
      return
    }
  }

  identify (id, attributes) {
    if (!this.checkEligibility()) {
      return
    }
  }

  trackEvent (eventName, attributes) {
    if (!this.checkEligibility()) {
      return
    }
  }

  trackPageEvent (pageName) {
    if (!this.checkEligibility()) {
      return
    }
  }

  reset () {
    if (!this.checkEligibility()) {
      return
    }
  }
}

export default new Analytics()
